/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminDebugSubscription200Response } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAdminUserSubscriptions200Response } from '../models';
/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 구독의 상세 디버그 정보를 조회합니다
         * @summary 관리자용 구독 디버그
         * @param {string} subscriptionId 디버그할 구독 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDebugSubscription: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('adminDebugSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/v1/admin/subscriptions/{subscriptionId}/debug`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자용 사용자 구독 조회 (v2)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserSubscriptions: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminUserSubscriptions', 'userId', userId)
            const localVarPath = `/api/v1/admin/users/{userId}/subscriptions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
         * @summary 관리자용 사용자 구독 조회
         * @param {string} userId 조회할 사용자 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserSubscriptions_1: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminUserSubscriptions_1', 'userId', userId)
            const localVarPath = `/api/v1/admin/subscriptions/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 구독의 상세 디버그 정보를 조회합니다
         * @summary 관리자용 구독 디버그
         * @param {string} subscriptionId 디버그할 구독 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDebugSubscription(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDebugSubscription200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDebugSubscription(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminDebugSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자용 사용자 구독 조회 (v2)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserSubscriptions(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminUserSubscriptions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserSubscriptions(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getAdminUserSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
         * @summary 관리자용 사용자 구독 조회
         * @param {string} userId 조회할 사용자 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserSubscriptions_1(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminUserSubscriptions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserSubscriptions_1(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getAdminUserSubscriptions_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 구독의 상세 디버그 정보를 조회합니다
         * @summary 관리자용 구독 디버그
         * @param {AdminApiAdminDebugSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDebugSubscription(requestParameters: AdminApiAdminDebugSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDebugSubscription200Response> {
            return localVarFp.adminDebugSubscription(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자용 사용자 구독 조회 (v2)
         * @param {AdminApiGetAdminUserSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserSubscriptions(requestParameters: AdminApiGetAdminUserSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminUserSubscriptions200Response> {
            return localVarFp.getAdminUserSubscriptions(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
         * @summary 관리자용 사용자 구독 조회
         * @param {AdminApiGetAdminUserSubscriptions0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserSubscriptions_1(requestParameters: AdminApiGetAdminUserSubscriptions0Request, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminUserSubscriptions200Response> {
            return localVarFp.getAdminUserSubscriptions_1(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - interface
 * @export
 * @interface AdminApi
 */
export interface AdminApiInterface {
    /**
     * 구독의 상세 디버그 정보를 조회합니다
     * @summary 관리자용 구독 디버그
     * @param {AdminApiAdminDebugSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    adminDebugSubscription(requestParameters: AdminApiAdminDebugSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDebugSubscription200Response>;

    /**
     * 
     * @summary 관리자용 사용자 구독 조회 (v2)
     * @param {AdminApiGetAdminUserSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getAdminUserSubscriptions(requestParameters: AdminApiGetAdminUserSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminUserSubscriptions200Response>;

    /**
     * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
     * @summary 관리자용 사용자 구독 조회
     * @param {AdminApiGetAdminUserSubscriptions0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getAdminUserSubscriptions_1(requestParameters: AdminApiGetAdminUserSubscriptions0Request, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminUserSubscriptions200Response>;

}

/**
 * Request parameters for adminDebugSubscription operation in AdminApi.
 * @export
 * @interface AdminApiAdminDebugSubscriptionRequest
 */
export interface AdminApiAdminDebugSubscriptionRequest {
    /**
     * 디버그할 구독 ID
     * @type {string}
     * @memberof AdminApiAdminDebugSubscription
     */
    readonly subscriptionId: string
}

/**
 * Request parameters for getAdminUserSubscriptions operation in AdminApi.
 * @export
 * @interface AdminApiGetAdminUserSubscriptionsRequest
 */
export interface AdminApiGetAdminUserSubscriptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiGetAdminUserSubscriptions
     */
    readonly userId: string
}

/**
 * Request parameters for getAdminUserSubscriptions_1 operation in AdminApi.
 * @export
 * @interface AdminApiGetAdminUserSubscriptions0Request
 */
export interface AdminApiGetAdminUserSubscriptions0Request {
    /**
     * 조회할 사용자 ID
     * @type {string}
     * @memberof AdminApiGetAdminUserSubscriptions0
     */
    readonly userId: string
}

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI implements AdminApiInterface {
    /**
     * 구독의 상세 디버그 정보를 조회합니다
     * @summary 관리자용 구독 디버그
     * @param {AdminApiAdminDebugSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminDebugSubscription(requestParameters: AdminApiAdminDebugSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminDebugSubscription(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자용 사용자 구독 조회 (v2)
     * @param {AdminApiGetAdminUserSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getAdminUserSubscriptions(requestParameters: AdminApiGetAdminUserSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getAdminUserSubscriptions(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
     * @summary 관리자용 사용자 구독 조회
     * @param {AdminApiGetAdminUserSubscriptions0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getAdminUserSubscriptions_1(requestParameters: AdminApiGetAdminUserSubscriptions0Request, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getAdminUserSubscriptions_1(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}

